import React, { useState, useEffect, useCallback, useMemo } from "react";
import { isFileTypeImage, getFileExtension, getImageFilePath } from "./FileColumnRenderer"; // reuse helpers
import FileViewer from "./FileViewer";
import { makeStyles } from "@material-ui/core/styles";
import { parseFiles} from "../ReusableColumnEditorsFactory/ColumnEditorFactory";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        maxWidth: "100%",
        maxHeight: "100%",
    },
    image: {
        height: "48px",
        width: "48px",
        objectFit: "cover",
        borderRadius: 4,
        cursor: "pointer",
    },
    fileIcon: {
        width: "48px",
        height: "48px",
        margin: "2px",
        cursor: "pointer",
        fontSize: "32px"
    },
}));

const useStylesForSubsheet = makeStyles(() => ({
    container: {
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        maxWidth: "100%",
        maxHeight: "120px",
    },
    image: {
        height: "36px",
        width: "36px",
        objectFit: "cover",
        borderRadius: 4,
        cursor: "pointer",
    },
    fileIcon: {
        width: "36px",
        height: "36px",
        margin: "2px",
        cursor: "pointer",
        fontSize: "20px"
    },
}));

const FileViewerForRowDetailPanel = ({ value, rowHeight = 36, isSubsheet = false, column, nodeData, isReadOnly = false, setLoading, handleSaveValue, isLookup = false, bodyRef, store }) => {
    const classes = useStyles();
    const subsheetClasses = useStylesForSubsheet();
    const [viewerOpen, setViewerOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const files = useMemo(() => parseFiles(value), [value]);
    // const [files, setFiles] = useState(parseFiles(value));

    // useEffect(() => {
    //     setFiles(parseFiles(value));
    // }, [value]);

    // const handleOpenViewer = (index) => {
    //     setStartIndex(index);
    //     setViewerOpen(true);
    // };
    const handleOpenViewer = useCallback((index) => {
        setStartIndex(index);
        setViewerOpen(true);
    }, []);

    const hasEditPermissions = () => {
        return window.appStore?.containerStore?.permissions.canEdit(column.id, nodeData) ?? false;
    }

    const handleFilesChange = async(updatedFiles, currentIndex = null) => {
        try {
            store.rowDetailScrollPos = bodyRef?.current?.scrollTop ?? (store.rowDetailScrollPos ?? 0);
            // setLoading(true);
            // setFiles(parseFiles(updatedFiles));
            await handleSaveValue(updatedFiles, value, column);

            if ((updatedFiles.length === 0)) {
                setViewerOpen(false);
            } 
            else {
                currentIndex !== startIndex && setStartIndex(currentIndex);
            }
        } catch (error) {
            console.error("Error handling files change: ", error);
        } 
        // finally {
            // setLoading(false);
        // }
    };

    return (
        <>
        <div className={isSubsheet ? subsheetClasses.container : classes.container}>
            {files.map((file, index) => {
                const ext = getFileExtension(file);
                if (isFileTypeImage(ext)) {
                    return (
                        <img
                            key={index}
                            alt={file.name}
                            src={getImageFilePath(file, rowHeight - 4)}
                            className={`${isSubsheet ? subsheetClasses.image : classes.image} loading_gif`}
                            onClick={() => handleOpenViewer(index)}
                        />
                    );
                }
                return (
                    <span
                        key={index}
                        className={`fiv-sqo fiv-icon-blank fiv-icon-${ext} ${isSubsheet ? subsheetClasses.fileIcon : classes.fileIcon}`}
                        onClick={() => handleOpenViewer(index)}
                    />
                );
            })}
        </div>

        {viewerOpen && (
            <FileViewer
                open={viewerOpen}
                onClose={() => setViewerOpen(false)}
                startIndex={startIndex}
                files={files}
                onChange={handleFilesChange}
                hasEditPermissions={hasEditPermissions}
                nodeData={nodeData}
                isReadOnly={isReadOnly}
                isSubsheetFromRowViewPanel={isSubsheet}
                isEditable={hasEditPermissions() && !isReadOnly && !isLookup}
                forRowDetailPanelView={true}
            />
        )}
        </>
    );
};

export default FileViewerForRowDetailPanel;